import { useNavigate, useParams } from "react-router-dom";
import AppInfo from "../../Pages/Report/AppInfo";

import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ActivitiesTable from "../../Pages/Report/ActivitiesTable";

import AboutProject from "../../Pages/Report/AboutProject";
import SubObjectives from "../../Pages/Report/SubObjectives";
import ButtonAHSF from "../../Components/ButtonAHSF";

import BudgetItem from "../../Pages/Report/BudgetItem";

import { StartProgressReport } from "../../Redux/Reducers/ReportStage/StartProgressReport";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  ChangeReportStatus,
  EditReportProjectObjective,
  GetSpecificRowReport,
} from "../../Redux/Reducers/ReportStage/Report";
import Swal from "sweetalert2";

const ProgressReportPreparation = () => {
  const navigate = useNavigate();
  const [disabled, setdisabled] = useState(false);
  const [overallProjectObjective, setOverallProjectObjective] = useState("");
  const [expectedProjectDeliverables, setExpectedProjectDeliverables] =
    useState("");
  const [AgreementAttachment, setAgreementAttachment] = useState(null);
  const ReportRow = useSelector((state) => state.ReportStatus.ReportRow);
  const dispatch = useDispatch();

  const { reportId } = useParams();
  const changeReportStatus = async (statusId) => {
    const result = await dispatch(
      ChangeReportStatus({
        reportId: reportId,
        reportStatusId: statusId,
      }),
    );
    if (result.payload.success) {
      navigate("/SRFund/report/ReportStageRequest/");
    }
  };
  useEffect(() => {
    dispatch(GetSpecificRowReport({ reportId: reportId }));
  }, [reportId]);
  console.log(ReportRow?.reportStatusId, "sssssssdwdwdwd");

  useEffect(() => {
    if (ReportRow?.reportStatusId == "") {
    }
  }, []);

  const EditReportProjectObjectiveFunction = async () => {
    const formData = new FormData();
    formData.append("ReportId", reportId);
    formData.append("OverallProjectObjective", overallProjectObjective==null?"":overallProjectObjective);
    formData.append("ExpectedProjectDeliverables", expectedProjectDeliverables==null?"":expectedProjectDeliverables);
    formData.append("AgreementAttachment", AgreementAttachment);

    var result = await dispatch(EditReportProjectObjective(formData));
    console.log(result.payload, "result.payload");

    return result.payload.success;
  };

  useEffect(() => {
    if (ReportRow?.reportStatusId == "e52ab9e0-dffa-4969-a2ba-efd28a41b148") {
      setdisabled(true);
    } else {
      setdisabled(false);
    }
    if (ReportRow?.reportStatusId == "40cf9fc6-4fb4-4b22-ad03-83a248d6d011") {
      setdisabled(true);
    }
  }, [ReportRow]);
  console.log(
    ReportRow?.reportStatusId != "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a",
    "ReportRow?.reportStatusId",
  );
console.log(ReportRow,"overallProjectObjective");

  return (
    <>
      {ReportRow?.reportStatusId ? (
        <>
          <AppInfo reportId={reportId} />
          {ReportRow ? (
            <AboutProject
              disabled={disabled}
              ReportRow={ReportRow}
              setOverallProjectObjective={setOverallProjectObjective}
              setExpectedProjectDeliverables={setExpectedProjectDeliverables}
              setAgreementAttachment={setAgreementAttachment}
              reportId={reportId}
            />
          ) : (
            <></>
          )}

          <SharedDiv
            showTitle={true}
            titleName="الأنشطة"
            child={[
              <>
                <ActivitiesTable
                  disabled={
                    ReportRow?.reportStatusId !=
                    "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a"
                  }
                  reportId={reportId}
                />
              </>,
            ]}
          />
          <SharedDiv
            showTitle={true}
            titleName="الأهداف الفرعية"
            child={[
              <>
                <SubObjectives
                  disabled={
                    ReportRow?.reportStatusId !=
                    "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a"
                  }
                  reportId={reportId}
                />
              </>,
            ]}
          />
          <SharedDiv
            showTitle={true}
            titleName="بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان "
            child={[
              <>
                <BudgetItem
                  disabled={
                    ReportRow?.reportStatusId !=
                    "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a"
                  }
                  reportId={reportId}
                />
              </>,
            ]}
          />
          {[
            "e52ab9e0-dffa-4969-a2ba-efd28a41b148",
            "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a",
          ].includes(ReportRow?.reportStatusId) && (
            <SharedDiv
              showTitle={true}
              titleName="الإجراءات على الطلب"
              child={[
                <>
                  <div
                    className="containerButtonMAin"
                    style={{ justifyContent: "center" }}
                  >
                    {ReportRow?.reportStatusId ===
                      "e52ab9e0-dffa-4969-a2ba-efd28a41b148" && (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            Swal.fire({
                              // title: "هل أنت متأكد؟",
                              title: "هل أنت متأكد من إرجاع الطلب للتعديل؟",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonText: "نعم، أرجع للتعديل",
                              cancelButtonText: "إلغاء",
                              reverseButtons: true,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                changeReportStatus(
                                  "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a",
                                );
                              }
                            });
                          }}
                          disabled={false}
                          title={"ارجاع للتعديل"}
                          text={"ارجاع للتعديل"}
                          show={true}
                        />
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            changeReportStatus(
                              "40cf9fc6-4fb4-4b22-ad03-83a248d6d011",
                            );
                          }}
                          disabled={false}
                          title={"بدء الدعم"}
                          text={"بدء الدعم"}
                          show={true}
                        />
                      </>
                    )}

                    {ReportRow?.reportStatusId ===
                      "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a" && (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            const missingFields = [];

                            if (
                              !overallProjectObjective ||
                              overallProjectObjective.trim() === ""
                            ) {
                              missingFields.push("الهدف العام للمشروع");
                            }

                            if (
                              !expectedProjectDeliverables ||
                              expectedProjectDeliverables.trim() === ""
                            ) {
                              missingFields.push("المخرجات المتوقعة");
                            }

                            if (
                              !AgreementAttachment ||
                              AgreementAttachment.length === 0
                            ) {
                              missingFields.push("مرفق الاتفاقية");
                            }

                            if (missingFields.length > 0) {
                              Swal.fire({
                                title: "الرجاء تعبئة الحقول التالية",
                                html: `
                        <div style="text-align: right; direction: rtl; font-size: 16px;">
                          <ul style="list-style-type: none; padding: 0;">
                            ${missingFields
                              .map(
                                (field) =>
                                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`,
                              )
                              .join("")}
                          </ul>
                        </div>
                      `,
                                icon: "warning",
                                confirmButtonText: "حسناً",
                              });
                              return;
                            }
                            const result = EditReportProjectObjectiveFunction();
                            if (result) {
                              changeReportStatus(
                                "e52ab9e0-dffa-4969-a2ba-efd28a41b148",
                              );
                              navigate("/SRFund/report/ReportStageRequest/");
                            }
                          }}
                          disabled={false}
                          title={"التحويل الى الموافقة"}
                          text={"التحويل الى الموافقة"}
                          show={true}
                        />

                        <div className="SaveButtonMarks">
                          <ButtonAHSF
                            type={"submitter"}
                            onClick={EditReportProjectObjectiveFunction}
                            disabled={false}
                            text={"حفظ"}
                            show={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </>,
              ]}
            />
          )}

          {/* <SharedDiv
            showTitle={true}
            titleName="الإجراءات على الطلب"
            child={[
              <>
                <div
                  className="containerButtonMAin "
                  style={{ justifyContent: "center" }}
                >
                  {ReportRow?.reportStatusId ==
                  "e52ab9e0-dffa-4969-a2ba-efd28a41b148" ? (
                    <>
                      <ButtonAHSF
                        type={"submitter"}
                        onClick={() => {
                          changeReportStatus(
                            "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a"
                          );
                        }}
                        disabled={false}
                        title={"ارجاع للتعديل"}
                        text={"ارجاع للتعديل"}
                        show={true}
                      />
                      <ButtonAHSF
                        type={"submitter"}
                        onClick={() => {
                          changeReportStatus(
                            "40cf9fc6-4fb4-4b22-ad03-83a248d6d011"
                          );
                        }}
                        disabled={false}
                        title={"بدء الدعم"}
                        text={"بدء الدعم"}
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {ReportRow?.reportStatusId ==
                  "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a" ? (
                    <>
                      <ButtonAHSF
                        type={"submitter"}
                        onClick={() => {
                          const missingFields = [];

                          if (
                            !overallProjectObjective ||
                            overallProjectObjective.trim() === ""
                          ) {
                            missingFields.push("الهدف العام للمشروع");
                          }

                          if (
                            !expectedProjectDeliverables ||
                            expectedProjectDeliverables.trim() === ""
                          ) {
                            missingFields.push("المخرجات المتوقعة");
                          }

                          if (
                            !AgreementAttachment ||
                            AgreementAttachment.length === 0
                          ) {
                            missingFields.push("مرفق الاتفاقية");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
                                  <div style="text-align: right; direction: rtl; font-size: 16px;">
                                    <ul style="list-style-type: none; padding: 0;">${missingFields
                                      .map(
                                        (field) =>
                                          `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                      )
                                      .join("")}</ul>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          changeReportStatus(
                            "e52ab9e0-dffa-4969-a2ba-efd28a41b148"
                          );
                          EditReportProjectObjectiveFunction();
                        }}
                        disabled={false}
                        title={"التحويل الى الموافقة"}
                        text={"التحويل الى الموافقة"}
                        show={true}
                      />

                      <div className="SaveButtonMarks">
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={EditReportProjectObjectiveFunction}
                          disabled={false}
                          // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                          text={"حفظ"}
                          show={true}
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </>,
            ]}
          /> */}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProgressReportPreparation;
